

export function setCookie(key, value, t) {

  let oDate = new Date()
  oDate.setDate(oDate.getDate() + t)
  document.cookie = key + '=' + value + ';expires=' + oDate.toGMTString()
}
export function getCookie(key) {
  var arr1 = document.cookie.split('; ')
  for (var i = 0; i < arr1.length; i++) {

      var arr2 = arr1[i].split('=')
      if (arr2[0] == key) {

          return decodeURI(arr2[1])
      }
  }
}
export function removeCookie(key) {
  setCookie(key, '', -365)
}

export function getQueryParams() {
  var url = location.search; //获取url中"?"符后的字串
  //console.log("url---", location);
  var theRequest = new Object()
  if (url.indexOf('?') != -1) {
    var strs = url.substr(1)
    strs = strs.split('&')
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split("=")[1])

    }
  }
  return theRequest
}
export function formatDate(date) {
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    var hours = date.getHours()
    var minutes = date.getMinutes()
    var seconds = date.getSeconds()

    month = month < 10 ? '0' + month : month
    day = day < 10 ? '0' + day : day
    hours = hours < 10 ? '0' + hours : hours
    minutes = minutes < 10 ? '0' + minutes : minutes
    seconds = seconds < 10 ? '0' + seconds : seconds

    var str = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds

    return str
}
